export default "__VITE_ASSET__4754cc70__"